<template>
  <div style="padding: 5px;">
    <UserApproval />
  </div>
</template>
<script>
import UserApproval from "./components/userApproval";
export default {
  components: { UserApproval },
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
